module.exports = __webpack_public_path__ + "img/slide-6.98fb2938.webp";